import React from 'react';
import { Helmet } from 'react-helmet';
import { SectionHero } from './products/ledger/_hero';
import { SectionAccuracy } from './products/ledger/_accuracy';
import { SectionRecord } from './products/ledger/_record';
import { SectionCloser } from './index/_closer';
import { Layout } from '~/components/Layout';
import { AllProducts } from '~/components/AllProducts';
import { Testimonials } from '~/components/Testimonials';
import { Footer } from '~/components/Footer';

const LedgerPage: React.FC = () => {
  return (
    <Layout noFooter bg="#F6F7FA">
      <Helmet>
        <title>Ledger — Column</title>
        <meta property="og:title" content="Column - Ledger" />
        <meta
          name="description"
          content="Ledger each transaction onto our proprietary modern system of record. Complete visibility and full banking functionality with the ease of an API."
        />
      </Helmet>
      <SectionHero />
      <SectionAccuracy />
      <SectionRecord />
      <Testimonials />
      <AllProducts background="#F6F7FA" accentColor="#E7E9EE" />

      <div className="relative overflow-hidden">
        <SectionCloser />
        <Footer />
      </div>
    </Layout>
  );
};

export default LedgerPage;
